import Vue from 'vue';
import * as types from '@/store/mutation-types';

export default {
  [types.setLoggedInPerson](state, person) {
    state.loggedInPerson = person;
    state.lastCommentReadDateAtLogin = person.lastCommentReadDate;
  },
  [types.setPersonProperties](state, update) {
    Object.assign(update.updatePerson, update.newPersonProperties);
  },
  [types.setPersonList](state, list) {
    Vue.set(state, 'persons', list);
  },
  [types.addPerson](state, update) {
    if (!state.persons[update.newPerson._id]) {
      Vue.set(state.persons, update.newPerson._id, update.newPerson);
    }
  },
  [types.deletePerson](state, { person }) {
    if (state.persons[person._id]) {
      Vue.delete(state.persons, person._id);
    }
  },
};



// WEBPACK FOOTER //
// ./src/store/person/personMutations.js